import type { NavIconName } from './NavIcon.js';

export interface NavItem {
  to: string;
  label: string;
  icon: NavIconName;
  /** Match this path exactly rather than as a prefix. */
  end?: boolean;
}

export const NAV_ITEMS: readonly NavItem[] = [
  { to: '/', label: 'Overview', icon: 'overview', end: true },
  { to: '/stores', label: 'Stores', icon: 'stores' },
  { to: '/screens', label: 'Screens', icon: 'screens' },
  { to: '/media', label: 'Media', icon: 'media' },
  { to: '/playlists', label: 'Playlists', icon: 'playlists' },
  { to: '/devices', label: 'Devices', icon: 'devices' },
  { to: '/audit', label: 'Audit log', icon: 'audit' },
];

export function sectionTitle(pathname: string): string {
  const match = NAV_ITEMS.find((item) =>
    item.end === true ? pathname === item.to : pathname.startsWith(item.to),
  );
  return match?.label ?? 'Pizza Bros TV';
}
